/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

/* eslint-disable import/max-dependencies */ // Disable max-dependencies. As Main switch, it'll have a lot of imports by design
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Loader } from "@nordcloud/gnui";
import { App } from "~/App";
import { GuardedRoute, Role } from "~/services/access";
import { Page404 } from "~/views/404";
import { ROUTES } from "./routes";

const Organizations = lazy(() => import("./views/organizations/organizationsList"));

const CreateOrganization = lazy(() => import("./views/organizations/createOrganization"));

const OrganizationDetails = lazy(() => import("./views/organizations/organizationDetails"));

const MSPAccounts = lazy(() => import("./views/accounts/accountsList"));

const MSPAccountDetails = lazy(() => import("./views/accounts/accountDetails"));

const MSPAccountCreation = lazy(() => import("./views/accounts/createAccount"));

export function GlobalSwitch() {
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<Navigate replace to={ROUTES.organizations.index} />} />
        <Route
          path={ROUTES.organizations.index}
          element={
            <Suspense fallback={<Loader />}>
              <Organizations />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.organizations.create}
          element={
            <Suspense fallback={<Loader />}>
              <CreateOrganization />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.organizations.details}
          element={
            <Suspense fallback={<Loader />}>
              <OrganizationDetails />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.accounts.index}
          element={
            <Suspense fallback={<Loader />}>
              <MSPAccounts />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.accounts.details}
          element={
            <Suspense fallback={<Loader />}>
              <MSPAccountDetails />
            </Suspense>
          }
        />
        <Route
          path={ROUTES.accounts.create}
          element={
            <GuardedRoute roles={[Role.MSP_PANEL_ADMIN]}>
              <Suspense fallback={<Loader />}>
                <MSPAccountCreation />
              </Suspense>
            </GuardedRoute>
          }
        />
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  );
}
